export function generateUniqueId() {
  const timestamp = Date.now();
  const randomComponent = Math.random().toString(36).slice(2, 11);
  return `${timestamp}-${randomComponent}`;
}
